import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

function Sidebar({ onLogout, user }) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { icon: '📊', label: 'Dashboard', path: '/projects' },
    { icon: '📱', label: 'QR Codes', path: '/projects' },
  ];

  // Add admin menus if user is admin
  if (user?.is_admin) {
    menuItems.push({ icon: '🎁', label: 'Giveaway', path: '/giveaway' });
    menuItems.push({ icon: '🔐', label: 'Admin', path: '/admin' });
  }

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <img src={logo} alt="Spark QR" style={{ height: '40px', marginBottom: '0.5rem' }} />
        <h2 style={{ fontSize: '1.25rem' }}>Spark QR</h2>
        <p style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.5)', margin: 0 }}>
          a product of BizHub
        </p>
      </div>

      <div className="sidebar-menu">
        {menuItems.map((item, index) => (
          <button
            key={item.label}
            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="menu-item-icon">{item.icon}</span>
            <span>{item.label}</span>
            {item.badge && (
              <span
                style={{
                  marginLeft: 'auto',
                  padding: '0.125rem 0.5rem',
                  background: 'var(--danger)',
                  borderRadius: '10px',
                  fontSize: '0.7rem'
                }}
              >
                {item.badge}
              </span>
            )}
          </button>
        ))}
      </div>

      <div style={{ padding: '1rem', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <button
          className="menu-item"
          onClick={onLogout}
          data-testid="sidebar-logout"
        >
          <span className="menu-item-icon">🚪</span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
